import { UseFieldArrayAppend } from "react-hook-form";
import { ButtonPrimary } from "../../../components/NewButtons";
import { AddScheduleModal } from "./AddScheduleModal";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { OverwriteMenuModalFormValues } from "./OverwriteMenuModal";

type Props = {
  append: UseFieldArrayAppend<OverwriteMenuModalFormValues, "schedules">;
};

export const AddScheduleSelector = ({ append }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <ButtonPrimary
        onClick={() => setIsOpen(true)}
        icon={<FontAwesomeIcon icon={solid("plus")} />}
      >
        Add schedule
      </ButtonPrimary>
      <AddScheduleModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        append={append}
      />
    </div>
  );
};
